import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { view01ImageOptions } from './views/View01'

class X43Sprayhood extends Component {
    constructor(props) {
        super(props);
        this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this);
        this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this);
    }
    
    handleSprayhoodChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SprayHood = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBoomCoverChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BoomCover = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.057336, -0.004583, 0, -0.00004,
                    0.013769, 0.142082, 0, 0.000077,
                    0, 0, 1, 0,
                    214, 380, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_3" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Sprayhood & Boom Cover' /></h1>

                    <p><Trans defaults='Excellent cockpit protection, with various options.' /></p>
                    <p><Trans defaults='In this configurator you can visualize the sprayhood options only. On the X4<sup>3</sup> model, we have developed 2 different versions of sprayhood - standard and extended.' /></p>
                    <p><Trans defaults='Apart from the options below - sprayhood and boom cover - there are also options for cockpit tent, bimini, cockpit cushions and forestay cover. These options are not included in the configurator. Please, contact your local dealer for more information.' /></p>
                    <h2><Trans defaults='Sprayhood' /></h2>
                    <MaterialSelector label={this.props.configuration.SprayHood.label} options={this.props.sprayhoodOptions} value={this.props.configuration.SprayHood} onChange={this.handleSprayhoodChange} />
                    
                    <h2><Trans defaults='Boom Cover' /></h2>
                    <MaterialSelector label={this.props.configuration.BoomCover.label} options={this.props.boomCoverOptions} value={this.props.configuration.BoomCover} onChange={this.handleBoomCoverChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X43Sprayhood);


// WEBPACK FOOTER //
// ./src/X43/X43Sprayhood.js